import { Locales } from '../../context/Localization/localization.types';
import { LegalDocumentType, LocaleKey } from './LegalDocumentModal/LegalDocumentModal.types';

const URL_MAP: Record<LegalDocumentType, Record<LocaleKey, string>> = {
    terms: {
        en: 'https://www.keytrak.com/ext/kiosk-terms',
        fr: 'https://www.keytrak.com/ext/kiosk-terms',
    },
    privacy: {
        en: 'https://www.keytrak.com/ext/kiosk-privacy-rights',
        fr: 'https://www.keytrak.com/fr/ext/kiosk-privacy-rights',
    },
};

export const getLegalDocumentUrl = (documentType: LegalDocumentType, locale: Locales): string => {
    const localeKey: LocaleKey = locale === Locales.fr ? 'fr' : 'en';

    return URL_MAP[documentType][localeKey];
};
